import moment from "moment";

export const formatDecimal = (value) => {
  return value.replace(/(\.)/gm, '').replace(/(,)/gm, '.')
};

export const formatCurrencyBRL = (value) => {
  if (!value) return "R$ 0,00";
  return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const numbersOnly = (str) => {
  return String(str).replace(/[^0-9]+/g, "");
};

export const stringsOnly = (str) => {
  return String(str).replace(/[^a-zA-Z_]+/g, "");
};

export const formatDate = function (date, hours = true) {
  if (date) {
    if (hours) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    }
    return moment(date).format("DD/MM/YYYY");
  }

  return null;
};

export const formatTime = function (date) {
  if (date) {
    return moment(date).format("HH:mm:ss");
  }

  return null;
};

export const formatDateToUs = function (date, convert = false) {
  if (date) {
    convert;
    return moment(date).format("YYYY-MM-DD");
  }

  return null;
};

export const formatDateDayMonth = function (date) {
  if (date) {
    return moment(date).format("DD/MM");
  }

  return null;
};

export const formatDateMonthYear = function (date) {
  if (date) {
    return moment(date).format("DD/MM/YYYY");
  }

  return null;
};

export const formatDateToMonthYear = function (date) {
  if (date) {
    return moment(date).format("MM/YYYY");
  }

  return null;
};

export const formatTimeOnlyNumbers = function (time = null) {
  if (time) {
    return String(time)
      .replace(":", "")
      .replace(":", "");
  }

  return null;
};

export const formatDateOnlyNumbers = function (date) {
  if (date) {
    return moment(date).format("YYYYMMDD");
  }

  return null;
};

export const formatDateToYearMonthDay = function (date = null) {
  if (date) {
    return moment(date).format("YYYY-MM-DD");
  }

  return null;
};

export const isNumeric = (value) => {
  var regra = /^[0-9]+$/;

  if (String(value).match(regra)) {
    return true;
  }

  return false;
};

export const formatValueToOnlyNumber = (value) => {
  value = String(value);
  value = value.replace(",", "");
  value = value.replace(".", "");
  value = value.replace(".", "");
  value = value.replace(".", "");

  return value;
};

export const formatValueToPercentage = (value) => {
  value = String(value);
  value = value.replace(",", ".");
  return value;
};

export const formatValueOnKeyUp = (value) => {
  value = value.replace(".", "");
  value = value.replace(".", "");
  value = value.replace(".", "");
  value = value.replace(",", "");
  if (!isNumeric(value)) {
    return "0,00";
  }
  return formatPrice(value);
};

export const formatValueNegativeOnKeyUp = (value) => {
  value = value.replace(".", "");
  value = value.replace(".", "");
  value = value.replace(".", "");
  value = value.replace(",", "");
  value = value.replace("-", "");
  if (!isNumeric(value)) {
    return "-0,00";
  }
  return `-${formatPrice(value)}`;
};

export const formatMoney = (value) => {
  value = value.replace(".", "");
  value = value.replace(".", "");
  value = value.replace(".", "");
  value = value.replace(",", "");

  return formatPrice(value);
};

export const formatPrice = (value) => {
  if (value) {
    let val = (value / 100).toFixed(2).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  return "";
};

/**
 * converte número para formato da moeda real
 * @param {number} value
 * @returns
 */
export function formatReal(value) {
  value = Number(value);
  if (!value) return "R$ 0,00";

  return value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    style: "currency",
    currency: "BRL",
    currencyDisplay: "symbol",
  });
}

/**
 * converte número para formato nacional
 * @param {number} value
 * @returns
 */
export function localeFormat(value) {
  value = Number(value);
  if (!value) return "";

  return value.toLocaleString("pt-BR", {
    minimumIntegerDigits: 1,
    minimumSignificantDigits: 1,
    minimumFractionDigits: 0,
    maximumSignificantDigits: 10,
    maximumFractionDigits: 10,
    style: "decimal",
    useGrouping: true,
  });
}

export const addDaysToDate = (days) => {
  return moment()
    .add(days, "days")
    .format("YYYY-MM-DD");
};

export const generateId = () => {
  let id = new Date().toISOString();
  id = id
    .replace("-", "")
    .replace("-", "")
    .replace("T", "")
    .replace(":", "")
    .replace(":", "")
    .replace(".", "")
    .replace("Z", "");

  return `${Math.floor(Math.random() * 2048)}${id}`;
};

export const onlyCodeCoren = (coren) => {
  if (coren) {
    coren = String(coren).replace(/[^a-zA-Z0-9]+/g, "");

    if (!coren.match(/^(COREN)([A-Z]{2})([0-9]{5,7})([A-Z]{2,4})$/)) {
      return false;
    }

    coren = coren.replace(
      /^(COREN)([A-Z]{2})([0-9]{3})([0-9]{2,4})([A-Z]{2,4})$/,
      '{"uf": "$2", "code": "$3$4", "category": "$5"}',
    );

    coren = JSON.parse(coren);

    return coren;
  }
  return false;
};

export const onlyCategoryCoren = (coren) => {
  coren = String(coren).replace(/[^a-zA-Z0-9]+/g, "");

  if (!coren.match(/^(COREN)([A-Z]{2})([0-9]{5,7})([A-Z]{2,4})$/)) {
    return false;
  }

  let categories = ["ENF", "OBST", "TE", "AE", "PAR", "AUT", "AT"];

  let cat = coren.replace(
    /^(COREN)([A-Z]{2})([0-9]{3})([0-9]{2,4})([A-Z]{2,4})$/,
    "$5",
  );

  if (categories.includes(cat)) {
    return cat;
  }

  return coren;
};

export const categoryCoren = (category) => {
  if (category) {
    let categories = {
      ENF: "Enfermeiro(a)",
      OBST: "Obstetriz",
      TE: "Técnico de Enfermagem",
      AE: "Auxiliar de Enfermagem",
      PAR: "Parteira",
      AUT: "Anotação do número de autorização",
      AT: "Atendente de Enfermagem",
    };

    return categories[category] || "";
  }
  return "";
};

export const professionalClassCouncilValue = ({
  id = null,
  name = "",
  profile = "",
  cpf = "",
  value = "",
  office = "",
}) => {
  const TYPE_COREN = 1;
  const TYPE_CRM = 2;
  // const TYPE_CRN = 3;
  // const TYPE_CREFONO = 4;
  // const TYPE_CRP = 5;
  // const TYPE_CREFITO = 6;
  profile;

  if (!name) {
    return "DEMO";
  }

  if (id == TYPE_COREN) {
    return `${name}, ${value} (${categoryCoren(onlyCategoryCoren(value))}) ${office ? ` - ${office}` : ""
      }`;
  } else if (id == TYPE_CRM) {
    return `Doutor(a) ${name} - ${value} ${office ? ` - ${office}` : ""}`;
  } else {
    if (id) {
      return `${name} - ${value} ${office ? ` - ${office}` : ""}`;
    }
  }

  if (cpf) {
    cpf = `${String(cpf).substring(0, String(cpf).length - 8)}...`;
  }

  return `${name}${cpf ? ` - ${cpf}` : ""} ${office ? ` - ${office}` : ""}`;
};

/**
 * conversões
 */

/**
 * retorna o tamanho do arquivo em b, kb, mb ou gb
 * @param {number} bytesLength tamanho do arquivo em bytes
 * @returns {string} tamanho do arquivo na unidade mais próxima
 */
export function formatFileSize(bytesLength) {
  const b = 1;
  const kb = b * 1024;
  const mb = kb * 1024;
  const gb = mb * 1024;

  if (bytesLength <= kb) return `${bytesLength} b`;
  else if (bytesLength <= mb) return `${(bytesLength / kb).toFixed(2)} kb`;
  else if (bytesLength <= gb) return `${(bytesLength / mb).toFixed(2)} mb`;
  else return `${(bytesLength / gb).toFixed(2)} gb`;
}
